import { taskOrIssueENUM } from "@mctypes/global.types";
import { IIssueApi } from "@schemas/issueSchema";
import { IconToggle, McDropdownBase } from "..";
import { usePostProjectByProjectIdIssuesCopyMutation } from "../../../openapi";
import { STANDARD_COLORS } from "../../app/globalConstants";
import { setShowSuccessMessageThunk } from "../../global/globalSlice";
import { useAppDispatch } from "../../hooks";
import { ToastMessagesEnums } from "../../mc-shared/sharedConstants";
import { IMcDropdownBase } from "../McDropdownBase/McDropdownBase";

const CopyIssueButton: React.FC<
  {
    issue: IIssueApi;
    taskOrIssue: taskOrIssueENUM;
  } & Omit<IMcDropdownBase, "children">
> = ({ issue, taskOrIssue, ...props }) => {
  const projectId = issue?.project;
  const issueId = issue?._id;

  const dispatch = useAppDispatch();

  const [postIssueCopy] = usePostProjectByProjectIdIssuesCopyMutation();

  const copyIssue = async (includeTasks: boolean) => {
    try {
      const response = await postIssueCopy({
        projectId,
        body: {
          issueId,
          includeTasks,
        },
      }).unwrap();

      console.log("✅ Issue copied successfully:", response);
    } catch (error) {
      dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.COPY_FAILED));
      console.error(error);
    }
  };

  return (
    <McDropdownBase
      customTrigger={
        <IconToggle
          activeIcon="files-o"
          inactiveIcon="files-o"
          toggled={false}
          activeColor={STANDARD_COLORS.orange}
          onClick={() => {}}
        />
      }
      className={"dropdown-row-end"}
      {...props}
    >
      {taskOrIssue === "ISSUE" ? (
        <>
          <McDropdownBase.Option key={1} onClick={() => copyIssue(true)}>
            Lag kopi med aksjoner
          </McDropdownBase.Option>
          <McDropdownBase.Option key={0} onClick={() => copyIssue(false)}>
            Lag kopi uten aksjoner
          </McDropdownBase.Option>
        </>
      ) : (
        <McDropdownBase.Option key={0} onClick={() => copyIssue(false)}>
          Lag kopi
        </McDropdownBase.Option>
      )}
    </McDropdownBase>
  );
};
export default CopyIssueButton;
